import { IDENTIFICATION_TYPE } from './users';
import { Company } from '../Configs/general';

const CLIENT_IDENTIFICATION_TYPES = {
  CC: 1,
  PP: 2,
  CE: 3,
  NIT: 110
};

export const PARSED_CONSTRUCTOR_CLIENT_IDENTIFICATION_TYPE = {
  [CLIENT_IDENTIFICATION_TYPES.CC]: IDENTIFICATION_TYPE.CC,
  [CLIENT_IDENTIFICATION_TYPES.CE]: IDENTIFICATION_TYPE.CE,
  [CLIENT_IDENTIFICATION_TYPES.PP]: IDENTIFICATION_TYPE.PP,
  [CLIENT_IDENTIFICATION_TYPES.NIT]: IDENTIFICATION_TYPE.NIT
};

export const ConstructorRequestType = {
  Quotation: 'nueva-etapa',
  AditionalJob: 'adicional-obra',
  Subrogation: 'subrogacion'
};

export const ConstructorRequestTitle = {
  [ConstructorRequestType.Quotation]: 'Solicitar cotización de nueva etapa',
  [ConstructorRequestType.AditionalJob]: 'Solicitar un adicional de obra',
  [ConstructorRequestType.Subrogation]: 'Solicitar subrogación'
};

export const BLUEPRINT_FILE_EXTENSIONS = ['zip'];

const cadFileFormatText = `Archivo en formato ${BLUEPRINT_FILE_EXTENSIONS.join(
  ', '
)}`;

const QUOTATION_REQUEST_ATTACHMENTS = [
  {
    label: 'Cámara de comercio no mayor a 30 días',
    attachmentType: 'camara-comercio',
    required: true
  },
  {
    label: 'RUT no mayor a 1 año',
    attachmentType: 'RUT',
    required: true
  },
  {
    label: 'Cédula de ciudadanía del representante legal',
    attachmentType: 'cedula-representante',
    required: true
  },
  {
    label: 'Certificado de Estratificación',
    attachmentType: 'certificado-estratificacion',
    required: true
  },
  {
    label: 'Certificado de Nomenclatura',
    attachmentType: 'certificado-nomenclatura',
    required: true
  },
  {
    label: 'Listado de Nomenclaturas de cada unidad habitacional',
    attachmentType: 'listado-nomenclaturas',
    required: true
  },
  {
    label: 'Planta primer piso',
    attachmentType: 'planta-primer-piso',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Planta piso tipo',
    attachmentType: 'planta-piso-tipo',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Planta de cubierta',
    attachmentType: 'planta-cubierta',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Planta sótanos o semisotanos',
    attachmentType: 'planta-sotanos-semisotanos',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Cortes o fachadas',
    attachmentType: 'cortes-fachadas',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label:
      'Urbanísticos o implementación en formato CAD y ubicación del proyecto',
    attachmentType: 'urbanisticos-ubicacion-proyecto',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  }
];

const ADITIONAL_JOB_REQUEST_ATTACHMENTS = [
  {
    label: 'Cámara de comercio no mayor a 30 días',
    attachmentType: 'camara-comercio'
  },
  {
    label: 'RUT no mayor a 30 días',
    attachmentType: 'RUT'
  },
  {
    label: 'Cédula de ciudadanía del representante legal',
    attachmentType: 'cedula-representante'
  },
  {
    label: 'Certificado de libertad y tradición no mayor a 30 días',
    attachmentType: 'certificado-libertad'
  },
  {
    label: 'Certificado de Estratificación',
    attachmentType: 'certificado-estratificacion'
  },
  {
    label: 'Certificado de Nomenclatura',
    attachmentType: 'certificado-nomenclatura'
  },
  {
    label: 'Registro de clientes y usuarios',
    attachmentType: 'registro-clientes'
  },
  {
    label: 'Listado de Nomenclaturas de cada unidad habitacional',
    attachmentType: 'listado-nomenclaturas'
  },
  {
    label: 'Planta primer piso',
    attachmentType: 'planta-primer-piso',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Planta piso tipo',
    attachmentType: 'planta-piso-tipo',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Planta de cubierta',
    attachmentType: 'planta-cubierta',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Planta sótanos o semisotanos',
    attachmentType: 'planta-sotanos-semisotanos',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label: 'Cortes o fachadas',
    attachmentType: 'cortes-fachadas',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  },
  {
    label:
      'Urbanísticos o implementación en formato CAD y ubicación del proyecto',
    attachmentType: 'urbanisticos-ubicacion-proyecto',
    helperText: cadFileFormatText,
    validFileExtensions: BLUEPRINT_FILE_EXTENSIONS,
    required: true
  }
];

const SUBROGATION_REQUEST_ATTACHMENTS = [
  {
    label: 'Cámara de comercio no mayor a 30 días',
    attachmentType: 'camara-comercio',
    required: true
  },
  {
    label: 'RUT no mayor a 1 año',
    attachmentType: 'RUT',
    required: true
  },
  {
    label: 'Cédula de ciudadanía del representante legal',
    attachmentType: 'cedula-representante',
    required: true
  },
  {
    label: 'Carta de subrogación',
    attachmentType: 'carta-subrogacion',
    templateLink: '/carta-subrogacion-grupal.docx',
    required: true
  },
  {
    label: `Listado de ${Company.contractConjugation.regular.plural.main} a subrogar`,
    attachmentType: 'listado-contratos',
    templateLink: '/contratos-subrogacion.csv',
    helperText: 'Archivo en formato csv',
    validFileExtensions: ['csv'],
    required: true
  },
  {
    label: 'Certificado de Estratificación',
    attachmentType: 'certificado-estratificacion',
    required: false
  },
  {
    label: 'Certificado de Nomenclatura',
    attachmentType: 'certificado-nomenclatura',
    required: false
  },
  {
    label: 'Listado de Nomenclaturas de cada unidad habitacional',
    attachmentType: 'listado-nomenclaturas',
    required: true
  }
];

export const CONSTRUCTOR_REQUEST_ATTACHMENTS = {
  [ConstructorRequestType.Quotation]: QUOTATION_REQUEST_ATTACHMENTS,
  [ConstructorRequestType.AditionalJob]: ADITIONAL_JOB_REQUEST_ATTACHMENTS,
  [ConstructorRequestType.Subrogation]: SUBROGATION_REQUEST_ATTACHMENTS
};

export const CONSTRUCTOR_REQUEST_DEFAULT_SUBJECT = {
  [ConstructorRequestType.Quotation]: 'Cotización de nueva etapa',
  [ConstructorRequestType.AditionalJob]: 'Solicitud adicional de obra',
  [ConstructorRequestType.Subrogation]: 'Solicitud de subrogación'
};

export const CONSTRUCTOR_REQUEST_MAX_MB_FILE_SIZE = 50;
